import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpModule } from '@angular/http';

import { LayoutModule } from './layout/layout.module';
import { AppComponent } from './app.component';
import { LoaderModule, SharedModule } from './turnos/shared/shared.module';
import { TurnoCanceladoComponent } from './turnos/shared/turno-cancelado/turno-cancelado.component';

const appRoutes: Routes = [
  { path: 'turnos', loadChildren: 'app/turnos/turnos.module#TurnosModule' },
  { path: 'turno-cancelado', component: TurnoCanceladoComponent },
  { path: '**', redirectTo: 'turnos' }
];

@NgModule({
  declarations: [
    AppComponent,
    TurnoCanceladoComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
    LoaderModule.forRoot(),
    LayoutModule,
    SharedModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/app/app.module.ts